/* eslint-disable no-undef */
import { useEffect, useState, useContext } from 'react';
import { Table } from "ant-table-extensions";
import { EditOutlined } from "@ant-design/icons";
import { AuthContext } from 'shared/context/auth-context'
import { useLocation } from 'react-router-dom';
import { Card, Col } from "antd";
import useHttpClient from 'shared/hooks/http-hook';
import ExportData from "components/UIElements/ExportData";
import './myTable.css'
import DeleteTripForm from './DeleteTripForm';


export default function MyTable({ columns, style, onRow, endPoint, exportFilename, ContractTab, expandable, exportDataTitle, dataTransformer, pageSize }) {
    const showTotal = (total) => `Σύνολο: ${total}`

    const DEFAULT_PAGESIZE =  pageSize || 10
    const DEFAULT_CURRENT = 1

    const [sendRequestEndPoint, setSendRequestEndPoint] = useState()
    const [pagination, setPagination] = useState({ current: DEFAULT_CURRENT, pageSize: DEFAULT_PAGESIZE, showTotal });
    const { responseData, sendRequest, status, loading } = useHttpClient();
    const [deletedRevokedTrip, setDeletedRevokedTrip] = useState(false);
    const [expandedRows, setExpandedRows]= useState([]);
    const location = useLocation()
    const { roleUser } = useContext(AuthContext)
    const acceptedUsersForTripEdit = ["AnyTimeAdmin"]


    useEffect(() => {
        if (endPoint) {
            sendRequest({
                endpoint: endPoint?.concat(`&items=${DEFAULT_PAGESIZE}&page=${DEFAULT_CURRENT}`),
                method: 'GET',
            })
            setSendRequestEndPoint(endPoint?.concat(`&items=${DEFAULT_PAGESIZE}&page=${DEFAULT_CURRENT}`))
        }
    }, [endPoint, sendRequest, deletedRevokedTrip])

    useEffect(() => {
        if (responseData && (status === 'resolved' || status === 'rejected')) {
            setPagination({ ...pagination, current: responseData?.pageIndex, total: responseData?.totalCount })
        }
    }, [status, responseData?.pageIndex, responseData?.totalCount])

    const handleTableChange = (filters, pages, sorter) => {
        setPagination({ ...pagination, current: filters.current, pageSize: filters.pageSize })
        sendRequest({
            endpoint: endPoint?.concat(`&items=${filters.pageSize}&page=${filters.current}&BatteryVoltageOrder=${(sorter.field === 'batteryVoltage' && sorter.order === 'ascend') ? 0 : 1}`),
            method: 'GET',
        })
        setSendRequestEndPoint(endPoint?.concat(`&items=${filters.pageSize}&page=${filters.current}&BatteryVoltageOrder=${(sorter.field === 'batteryVoltage' && sorter.order === 'ascend') ? 0 : 1}`))
    }

    const defineDeviceOverviewStatus = () => {
        let itemsData;
        if (responseData?.items?.length > 0 && sendRequestEndPoint?.indexOf('PackingStatus') !== -1) itemsData = responseData?.items[0].status
        else if (responseData?.items?.length > 0 && sendRequestEndPoint?.indexOf('PackingStatus') === -1) itemsData = 'Όλες'
        else itemsData = 'Δεν βρέθηκε συσκευή'
        return itemsData
    }

    const handleExpand=(id)=>{
        setExpandedRows((prevExpandedRows)=> prevExpandedRows.includes(id) ? prevExpandedRows.filter(key => key !== id) : [...prevExpandedRows, id] )
    }

    return (
        <>
            {
                location.pathname === '/choices/packing-list/device-overview' ?
                    <Col className=".ant-col-offset-4" offset={4}>Σύνολο Συσκευών: {responseData?.totalCount}</Col>
                    : null
            }
            <Card type="inner">
                <ExportData
                    totalCount={responseData?.totalCount}
                    exportFilename={exportFilename}
                    status={status === "resolved" ? defineDeviceOverviewStatus() : null}
                    endPoint={endPoint}
                    columns={columns}
                    ContractTab={ContractTab}
                    title={exportDataTitle}
                />
                <Table
                    rowKey="id"                    
                    expandable={ acceptedUsersForTripEdit.includes(roleUser) ? (expandable && {
                        expandedRowRender: ({id}) =><DeleteTripForm tripId={id} setDeletedRevokedTrip={setDeletedRevokedTrip} deletedRevokedTrip={deletedRevokedTrip} handleExpand={handleExpand}/>,
                        expandedRowKeys: expandedRows,
                        onExpand: ((expanded, record)=>handleExpand(record.id)),
                        expandIcon: ({ onExpand, record }) =><EditOutlined onClick={e => onExpand(record, e)} />})
                        : null }
                    dataSource={dataTransformer ? dataTransformer(responseData?.items) : responseData?.items}
                    loading={loading}
                    rowClassName={(item) => item?.isActive === "0"? 'table-row-red' : null}
                    columns={columns}
                    pagination={pagination}
                    onRow={onRow}
                    style={{ ...style, overflowX: 'auto'}}
                    onChange={handleTableChange}
                />
            </Card>
        </>
    )
}